import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';

export function useInspectionsAdminDashboardFlag(): boolean {
  return useFlag(FeatureFlag.InspectionsAdminDashboard, false) ?? false;
}
